import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, DBTextField, DBDateField, DBTextArea, ExportButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';

class PatientCareCenterNoteGoalsGoalDetailsWCFreeForm extends React.Component {

    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }


    goalDropDownChanged() {
        if (this.props.goal.GOCUSTOM) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GOCUSTOM');
        }
        if (this.props.goal.GOFREEFORM) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GOFREEFORM');
        }
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    convertNote() {
        this.props.convertNote(this.props.noteId, 5); // PN/DN
    }

    render() {
        return (
            <div className={styles.goal_detail_wrapper}>
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label_req}>Name:</span>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTGOALS'
                        entityKeyColumn='GONO'
                        entityKeyValue={this.props.goal.GONO}
                        field='GOCUSTOM'
                        className={styles.text_field}
                        onChange={() => this.goalValueChanged()}
                        disabled={this.props.noteType !== 3 && this.props.noteType !== 5}
                    />
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label_req}>Progress:</span>
                    <span className={styles.goal_input}>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOGPNO'
                            masterEntity='PTMASTERGOALPROGRESS'
                            masterEntityKeyColumn='GPNO'
                            masterEntitySort='GPORDER'
                            masterEntityDisplay='GPNAME'
                            onChange={() => this.goalValueChanged()}
                        />
                    </span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={this.props.goal.GOCUSTOM === 'Independence with HEP' ? styles.goal_detail_label_top : styles.goal_detail_label_req_top}>Goal:</span>
                    <span className={styles.goal_input}>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOFREEFORM'
                            rows={5}
                            className={styles.text_area}
                            onChange={() => this.goalValueChanged()}
                            disabled={this.props.noteType !== 3 && this.props.noteType !== 5}
                        />
                    </span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label_req}>Date:</span>
                    <span className={styles.goal_input}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GODATE'
                            customMsg='The goal date cannot be in the past.'
                            minDate={getDateMMDDYYYY(new Date())}
                            onChange={() => this.goalValueChanged()}
                            disabled={this.props.noteType !== 3 && this.props.noteType !== 5}
                        />
                    </span>
                </div>

                {(this.props.noteType === 2 || this.props.noteType === 4 || this.props.noteType === 6) &&
                    <div>
                        <div className={styles.goal_detail_row}>
                            <label className={styles.convert_msg}>Need to edit additional goal details?  Convert this note to a PN by clicking here:</label>
                        </div>
                        <div className={styles.goal_detail_row}>
                            <span className={styles.convert_button}>
                                <ExportButton title='Convert to PN/DN' size='large' onClick={() => this.convertNote()} />
                            </span>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        convertNote: bindActionCreators(noteActions.convert, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;

    return {
        noteId,
        noteType,
        pk,
        goal,
        goalsUpdated
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsWCFreeForm = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsWCFreeForm);
export { connectedPatientCareCenterNoteGoalsGoalDetailsWCFreeForm as PatientCareCenterNoteGoalsGoalDetailsWCFreeForm };

